export default __webpack_public_path__ + "static/media/acms-work-flow.890c75ce.svg";